module.exports = __webpack_public_path__ + "assets/TrBySideAndCentroidDetailed.8b9d9eaf886483e88af7e711e482f1a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TrBySideAndCentroidDetailed.png
// module id = 589
// module chunks = 0